import {
  TOGGLE_RISK_SUCCESS,
  TOGGLE_RISK_FAILURE,
  TOGGLE_RISK_REQUEST,
  UPDATE_RISK_REQUEST,
  UPDATE_RISK_SUCCESS,
  UPDATE_RISK_FAILURE,
  CLEAR_RISK
} from '../constants'
import { clear } from "redux-localstorage-simple"

const defaultRiskState = {
  pending: false,
  id: null,
  result: false,
  hidden: null,
  updateSuccess: false,
  cellValue: '',
  row: {},
  risk: {},
}

export default (state = defaultRiskState, action) => {

  var newState = {...state}

  switch (action.type){
    case TOGGLE_RISK_REQUEST:
      newState.pending = true;
      newState.id = null
      newState.hidden = null
      newState.result = false
      newState.updateSuccess = false;
      return newState;
    case TOGGLE_RISK_SUCCESS:
      newState.pending = false
      newState.id = action.id
      newState.hidden = action.hidden
      newState.result = action.result
      return newState;
    case TOGGLE_RISK_FAILURE:
      return defaultRiskState;
    case UPDATE_RISK_REQUEST:
      newState.pending = true;
      newState.updateSuccess = false;
      return newState;
    case UPDATE_RISK_SUCCESS:
      newState.cellValue = action.cellValue;
      newState.risk = action.body;
      newState.row = action.row;
      newState.pending = false;
      newState.updateSuccess = true;
      newState.result = true;
      return newState;
    case UPDATE_RISK_FAILURE:
      newState.pending = false;
      newState.updateSuccess = false;
      return newState;
    case CLEAR_RISK:
      newState = defaultRiskState;
      clear(); //Clears the Redux LocalStorage
      return newState;
    default:  return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/risk.js